<template>
  <div class="map-control-container">
    <div class="map-control">
      <button :style="buttonStyles" @click="showTransportLayout" class="map-button">
        <img src="/transport.svg" alt="Transport" class="icon" />
        Modais de Transporte
      </button>
      <button :style="buttonStyles" @click="showTrafficLayout" class="map-button">
        <img src="/Delivery.svg" alt="Traffic" class="icon" />
        Tráfego
      </button>
      <button :style="buttonStyles" @click="showWeatherLayout" class="map-button">
        <img src="/Weather.svg" alt="Weather" class="icon" />
        Clima
      </button>
    </div>
    <Layouts :layoutType="changeMapType" :isLoadingArravalsData="isLoadingArravalsData" />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import Layouts from './Layouts/Layouts.vue'
import WeatherComponent from './Layouts/Components/Weather/Weather'
import { useInteractiveMap } from '../../../../stores/interactiveMap'
import { useCustomHeader } from '../../../../stores/customHeader'

export default {
  name: 'MapControl',
  props: {
    changeMapType: String,
    isLoadingArravalsData: Boolean,
    addCustomControls: Function,
    prediction: Function,
  },
  components: {
    Layouts,
  },
  data() {
    return {
      currentLayout: 'transport',
      buttonStyles: {
        backgroundColor: 'white',
        color: '#37434A',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '100px',
        border: 'none',
        cursor: 'pointer',
      },
    }
  },
  computed: {
    ...mapState(useCustomHeader, ['getDisableButtons']),
    ...mapState(useCustomHeader, ['getSubtitleCustomHeader']),
    ...mapState(useCustomHeader, ['getButtonsCustomHeader']),
  },
  methods: {
    async showTransportLayout() {
      const interactiveMap = useInteractiveMap()
      interactiveMap.changeMapType('transport')
      this.getDisableButtons(false)
      this.currentLayout = 'transport'
      const mapOptions = {
        tilt: 10,
        heading: 5,
        zoom: 19,
        center: { lat: -25.597576285627483, lng: -54.48808204999569 },
      }

      const locations = [
        {
          lat: -25.52032,
          lng: -54.56379,
          title: 'Terminal Rodoviária Internacional',
          type: 'rodoviaria',
        },
        {
          lat: -25.597576285627483,
          lng: -54.48808204999569,
          title: 'Aeroporto Internacional de Foz',
          type: 'aeroporto',
        },
      ]

      const withMarker = true
      const setMapTypeId = 'satellite'
      await this.$initMap(
        'interactive-map',
        mapOptions,
        locations,
        this.addCustomControls,
        setMapTypeId,
        withMarker,
        this.currentLayout,
      )
      this.$setTrafficLayer(false) // Desativa a camada de tráfego se estiver ativa
    },
    async showTrafficLayout() {
      const interactiveMap = useInteractiveMap()
      interactiveMap.changeMapType('traffic')
      this.getDisableButtons(false)
      this.currentLayout = 'traffic'
      this.prediction(0)
      const mapOptions = {
        tilt: 10,
        heading: 5,
        zoom: 19,
        center: { lat: -25.597576285627483, lng: -54.48808204999569 },
      }

      const locations = [
        {
          lat: -25.52032,
          lng: -54.56379,
          title: 'Terminal Rodoviária Internacional',
          type: 'rodoviaria',
        },
        {
          lat: -25.597576285627483,
          lng: -54.48808204999569,
          title: 'Aeroporto Internacional de Foz',
          type: 'aeroporto',
        },
      ]
      const mapTypeId = 'roadmap'
      const withMarker = false
      await this.$initTrafficMap(
        'interactive-map',
        mapOptions,
        locations,
        this.addCustomControls,
        mapTypeId,
        withMarker,
        this.currentLayout,
      )
    },
    async showWeatherLayout() {
      const interactiveMap = useInteractiveMap()
      interactiveMap.changeMapType('traffic')
      this.getSubtitleCustomHeader('Previsão')
      this.getDisableButtons(true)
      document.getElementById('interactive-map').style.display = 'none'
      document.getElementById('windy').style.display = 'block'
      this.$setTrafficLayer(false)

      this.$initWindyMap(
        'windy',
        {
          lat: -25.597576285627483,
          lon: -54.48808204999569,
          zoom: 10,
          key: '5xFhdwFu5PtGrivNp2y4p4CjejGzX7Sc', // Use a chave API passada ao registrar o plugin, se necessário
        },
        WeatherComponent,
      )
    },
  },
}
</script>

<style scoped>
.map-control-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.map-control {
  display: flex;
  background: transparent;
  border-radius: 16px;
  padding: 20px 0;
  z-index: 1000;
  pointer-events: auto;
}
button {
  display: inline-block;
  white-space: nowrap;
}
.map-control button:not(:first-child) {
  margin-left: 15px;
}
.map-button .icon {
  width: 24px;
  height: 24px;
}
</style>
